module.exports = __webpack_public_path__ + "static/media/icon-close-circle-lg.67aa3179.svg";